import { Link } from 'react-router-dom';
import { videos } from '@/mocks/videos';

const featuredVideos = videos.filter((v) => v.featured);

function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}万`;
  }
  return views.toString();
}

export default function FeaturedVideos() {
  return (
    <section className="w-full bg-background-100 py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-1">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500">精选优质内容，每日更新</p>
          </div>
          <Link
            to="/category/shenghuo"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer whitespace-nowrap flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featuredVideos.map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="group cursor-pointer"
            >
              <article className="rounded-xl overflow-hidden bg-background-50 hover:bg-background-50 transition-all duration-300">
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={video.thumbnail}
                    alt={video.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute bottom-2 right-2 bg-black/70 backdrop-blur-sm text-background-50 text-xs px-2 py-1 rounded-md whitespace-nowrap">
                    {video.duration}
                  </div>
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
                    <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <i className="ri-play-fill text-primary-500 text-2xl"></i>
                    </div>
                  </div>
                </div>
                <div className="p-3 md:p-4">
                  <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 leading-snug mb-2 group-hover:text-primary-600 transition-colors">
                    {video.title}
                  </h3>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <img
                        src={video.authorAvatar}
                        alt={video.author}
                        className="w-6 h-6 rounded-full object-cover"
                      />
                      <span className="text-xs text-foreground-500 whitespace-nowrap">{video.author}</span>
                    </div>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">
                      <i className="ri-eye-line mr-1"></i>{formatViews(video.views)}
                    </span>
                  </div>
                </div>
              </article>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}